import { TextField } from "@mui/material"

export function RenderSkillsInput(params) {
    return <TextField {...params} placeholder="Add Skills" />
}
